'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_api_DocumentsReadResponse(doc, watermark) {
  this.yU = null;
  this.Xq = null;
  this.yU = doc;
  this.Xq = watermark;
}
export { $c_Lapp_api_DocumentsReadResponse as $c_Lapp_api_DocumentsReadResponse };
$p = $c_Lapp_api_DocumentsReadResponse.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_api_DocumentsReadResponse;
/** @constructor */
function $h_Lapp_api_DocumentsReadResponse() {
}
export { $h_Lapp_api_DocumentsReadResponse as $h_Lapp_api_DocumentsReadResponse };
$h_Lapp_api_DocumentsReadResponse.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_api_DocumentsReadResponse)) {
    var x = this.yU;
    var x$2 = x$0.yU;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.Xq;
      var x$4 = x$0.Xq;
      return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 2;
});
$p.t = (function() {
  return "DocumentsReadResponse";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.yU;
  }
  if ((n === 1)) {
    return this.Xq;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "doc";
  }
  if ((n === 1)) {
    return "watermark";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_api_DocumentsReadResponse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.it)));
}
export { $isArrayOf_Lapp_api_DocumentsReadResponse as $isArrayOf_Lapp_api_DocumentsReadResponse };
var $d_Lapp_api_DocumentsReadResponse = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_api_DocumentsReadResponse, "app.api.DocumentsReadResponse", ({
  it: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_api_DocumentsReadResponse as $d_Lapp_api_DocumentsReadResponse };
//# sourceMappingURL=app.api.-Documents-Read-Response.js.map
